export default __webpack_public_path__ + "static/media/platziExchangeImg_2.ec1f90aa.webp";